import './style.css';
import axios from 'axios';
import React, { useState, useRef, useEffect } from 'react';
import XMLViewer from 'react-xml-viewer';
import localStorage from '../../../../utils/localStorage';
//import { SELECTEDFILE, XMLFORMAT } from '../../../../commons/api';
import { XMLFORMAT } from '../../../../commons/api';
import { getMasterById, getMaximoList } from '../../../AMM/Utils/FormCalls';
import {
  Input,
  Form,
  Col,
  Row,
  Select,
  Upload,
  Button,
  message,
  Tabs,
  Tooltip,
  Popconfirm,
  Modal
} from 'antd';
import {
  PlusOutlined,
  UploadOutlined,
  DoubleLeftOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import { StyledHomepage } from '../../../../commons/styles/layout';

const pd = require('pretty-data').pd;
const { Option } = Select;
const { TextArea } = Input;
const urlList = {
  getbyId: `${XMLFORMAT.GetById}`
};

const XMLConfiguration = (props) => {

  const [UniqueKeysList, setUniqueKeysList] = useState([]);
  const [uploadFileData, setUploadFileData] = useState({});
  //const [selectdeFileUploadData,setSelectedFileUploadData] = useState({});
  const [, setFileName] = useState(null);
  // const [DataObject,setDataObject] = useState('');MaximoXMLConfiguration
  const [, setChildXMLdata] = useState('');
  const [childDataObject, setChildDataObject] = useState('');
  const [PayloadType, setPayloadType] = useState('');
  const [xmlView, setXmlView] = useState(false);
  const [XmlViewData] = useState('');
  //const [sitesList,setSitesList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isChildModalVisible, setIsChildModalVisible] = useState(false);
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  const [parentData, setParentData] = useState({});
  const [TypeList, setTypeList] = useState([]);
  const [, setUniqueKeysChildList] = useState([]);
  const [AllChildList, setAllChildList] = useState({});
  const [AllUniqueKeyList] = useState([]);
  const [, setChildKeyList] = useState({});
  const [selectedObj, setSelectedObj] = useState({});
  const [ChildMappingKeysArray, setChildMappingKeysArray] = useState([]);
  const [AddParentDisable, setAddParentDisable] = useState(true);
  const [AddChildDisable] = useState(null);
  const [selectedChildIndex, setSelectedChildIndex] = useState('');

  let userRef = useRef(null);
  let formRef = useRef(null);
  //let childRef = useRef(null);

  useEffect(() => {
    _getDataById();
  }, []);

  const _getDataById = async (ItemId) => {
    let formObject = userRef.current.getFieldsValue();
    let path = props.location.pathname.split('/rubus/MaximoXMLConfiguration/');
    let formId = ItemId ? ItemId : path[1];
    if (formId !== '1') {
      let data = await getMasterById(urlList.getbyId, formId, 'GET');
      formObject = data && data !== undefined ? data : {};
    }
    if (userRef.current) {
      userRef.current.setFieldsValue(formObject);
    }
    setFormObject(formObject);
    if (formObject) {
      userRef.current.setFieldsValue(formObject);
    }
    let TypeList = await getMaximoList();
    setTypeList(TypeList);
  };

  const getUniqueKeysList = (payload) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const fileObject = {
      method: 'POST',
      url: `${XMLFORMAT.UniqueColumnsByXmlData}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(fileObject)
      .then((response) => {
        setUniqueKeysList(response.data);
        setAddParentDisable(false);
        return response;
      })
      .catch(function () { });
  };
  const getUniqueKeysChildList = (payload, index) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const fileObject = {
      method: 'POST',
      url: `${XMLFORMAT.UniqueColumnsByXmlData}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(fileObject)
      .then((response) => {
        let data = {
          ...AllUniqueKeyList,
          [index]: response.data
        };
        setUniqueKeysChildList(response.data);
        AllUniqueKeyList(data);
        AddChildDisable(false);
      })
      .catch(function () { });
  };
  const ShowXmlView = () => {
    setXmlView(!xmlView);
  };
  const handleChange = (info) => {
    const { status } = info.file;
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  //  * @author sapna.m
  //  * @description XMLConfigUpload function is used to read file data
  //  * @return Get content of file
  const XMLConfigUpload = (file) => {
    formRef.current && formRef.current.resetFields();
    userRef.current.resetFields(['DataObject']);
    userRef.current.resetFields(['UniqueKeys']);
    const reader = new FileReader();
    reader.onload = (e) => {
      const xml = e.target.result;
      // this.setState({
      //   // uploadFileData: minifyXML(xml), // avoiding minnifyXMl to prevent missing of random xml file content//
      //   uploadFileData: xml,
      //   filename: file.name,
      //   XmlViewData: xml,
      //   parentData: {}
      // });
      setUploadFileData(xml);
      setFileName(file.name);
      setXmlView(xml);
      setParentData({});

    };
    reader.readAsText(file);
    const isLt2M = file.size / 1024 / 1024 < 10;
    const isXML = file.type === 'text/xml';
    if (!isXML) {
      message.error('You can only upload xml file!');
    }
    if (!isLt2M) {
      message.error('xml file must be smaller than 10MB!');
    }
    return false;
  };

  //  * @author sapna.m
  // * @description This function is used to Save Form data
  const SaveConfigurationUpload = () => {
    userRef.current
      .validateFields()
      .then(async (values) => {
        if (parentData && Object.values(parentData).length !== 0 && values.child === undefined) {
          let fileObject = {
            Name: values.Name,
            type: 'Parent',
            DataObject: values.DataObject,
            XmlFormat: uploadFileData.replace(/"/g, "'"),
            PayloadType: values.PayloadType,
            UniqueKeys: values.UniqueKeys,
            MappingKeys: parentData,
            TableName: values.Type
          };
          if (
            fileObject &&
            fileObject.PayloadType === 'Response' &&
            fileObject.PayloadType !== 'Request'
          ) {
            fileObject['ResponseUrl'] = values.ResponseUrl;
            fileObject['Group'] = values.Group;
          }

          let statusResponse = saveConfigurationAPi(fileObject);

          if (statusResponse && statusResponse.message) {
            message.success('Record Submitted Successfully');
          } else if (statusResponse && statusResponse.Error) {
            message.error(statusResponse.Error);
          }
          if (userRef.current) {
            userRef.current.resetFields();
            setFormObject({});
          }
          if (formRef.current) {
            formRef.current.resetFields();
            setParentData({});
          }
          setUploadFileData({});
          setFileName('');
          setFormObject({});
          setParentData({});
          setAddParentDisable(false);
          setChildMappingKeysArray([]);
        } else if (
          values.child &&
          Array.isArray(values.child) &&
          values.child !== undefined &&
          ChildMappingKeysArray &&
          ChildMappingKeysArray.length !== 0
        ) {
          let fileObject = {
            Name: values.Name,
            type: 'Parent',
            DataObject: values.DataObject,
            XmlFormat: uploadFileData.replace(/"/g, "'"),
            PayloadType: values.PayloadType,
            UniqueKeys: values.UniqueKeys,
            MappingKeys: parentData,
            TableName: values.Type,
            child:
              ChildMappingKeysArray &&
              ChildMappingKeysArray[selectedChildIndex] &&
              Object.values(ChildMappingKeysArray[selectedChildIndex]).length !== 0 &&
              values.child &&
              Array.isArray(values.child) &&
              values.child.map((data, index) => {
                return {
                  DataObject: data.DataObject,
                  type: 'Child',
                  XmlFormat:
                    data.XmlFormat && data.XmlFormat
                      ? pd.xmlmin(data.XmlFormat).replace(/"/g, "'")
                      : data.XmlFormat,
                  UniqueKeys: data.UniqueKeys,
                  MappingKeys: ChildMappingKeysArray[index],
                  TableName: data.Type
                };
              })
          };
          if (
            fileObject &&
            fileObject.PayloadType === 'Response' &&
            fileObject.PayloadType !== 'Request'
          ) {
            fileObject['ResponseUrl'] = values.ResponseUrl;
            fileObject['Group'] = values.Group;
          }

          let statusResponse = saveConfigurationAPi(fileObject);

          if (statusResponse && statusResponse.message) {
            message.success('Record Submitted Successfully');
          } else if (statusResponse && statusResponse.Error) {
            message.error(statusResponse.Error);
          }
          if (userRef.current) {
            userRef.current.resetFields();
            setFormObject({});
          }
          if (formRef.current) {
            formRef.current.resetFields();
            setParentData({});
          }
          setUploadFileData({});
          setFileName('');
          setFormObject({});
          setParentData({});
          setAddParentDisable(false);
          setChildMappingKeysArray([]);
        } else if (parentData && Object.values(parentData).length === 0) {
          message.error('Please select Parent Mapping Keys');
        } else if (
          values.child &&
          Array.isArray(values.child) &&
          values.child !== undefined &&
          ChildMappingKeysArray &&
          ChildMappingKeysArray.length === 0
        ) {
          message.error('Please Select Child Mapping Keys');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onFormItemSubmit = (e) => {
    e.preventDefault();
    formRef.current &&
      formRef.current
        .validateFields()
        .then(async (values) => {
          setIsModalVisible(false);
          setParentData(values);
        })
        .catch((error) => {
          console.log(error);
        });
  };
  const onChildModalSubmit = () => {
    //  this.setState({selectedObj:{},isChildModalVisible:false})
    let data = {};
    if (selectedObj && Object.keys(selectedObj).length !== 0) {
      data = {
        ...ChildMappingKeysArray,
        [selectedChildIndex]: selectedObj
      };
      setSelectedObj({});
      setIsChildModalVisible(false);
      setChildMappingKeysArray(Object.values(data));
    } else {
      message.error('Please select atleast One Mapping Key');
    }
  };

  //APi for save
  const saveConfigurationAPi = (payload) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const fileObject = {
      method: 'POST',
      url: `${XMLFORMAT.CREATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(fileObject)
      .then(() => {
        message.success('Successfully Submitted');
        if (userRef.current) {
          userRef.current.resetFields();
          setFormObject({});
        }
      })
      .catch(function () {
        message.error('Error');
      });
  };

  //  * @author sapna.m
  // * @description This Function is used for getting uniqueKeys for multi select option
  const handleDataObject = (e) => {
    e.preventDefault();
    userRef.current.validateFields(['DataObject']).then(async (values) => {
      let fileObject = {
        DataObject: values.DataObject,
        XmlFormat: uploadFileData
      };
      getUniqueKeysList(fileObject); //uniqueKeys List will get from this function
    });
  };
  const handleDataObjectChild = (e) => {
    setChildDataObject(e.target.value);
  };
  const ChildXMLData = async (e, index) => {
    // e.preventDefault();
    setChildXMLdata(e.target.value);
    let formObject = {
      DataObject: childDataObject,
      XmlFormat: e.target.value
    };
    getUniqueKeysChildList(formObject, index);
  };
  const onHandleChanePayload = (value) => {
    setPayloadType(value);
  };
  const onAddMapping = () => {
    setIsModalVisible(true);
  };
  const onChildAdd = (selectedChildIndex) => {
    // check weather data exists are not
    let getMaximoKeysArray =
      AllUniqueKeyList &&
        AllUniqueKeyList[selectedChildIndex] &&
        AllUniqueKeyList[selectedChildIndex].dataKeys
        ? AllUniqueKeyList[selectedChildIndex].dataKeys
        : {};

    let keyList = {};
    getMaximoKeysArray &&
      Array.isArray(getMaximoKeysArray) &&
      getMaximoKeysArray.map((key) => {
        keyList[key] = '';
        return {};
      });

    let AllChildList = {
      ...AllChildList,
      [selectedChildIndex]: keyList
    };
    setIsChildModalVisible(true);
    setSelectedChildIndex(selectedChildIndex);
    setAllChildList(AllChildList);
    setChildKeyList(AllUniqueKeyList([selectedChildIndex]));

  };
  const onKeySelect = (data, value) => {
    let selectedObjData = {
      ...selectedObj,
      [data]: value
    };
    setSelectedObj(selectedObjData);
  };
  const onModalClose = () => {
    setIsModalVisible(false);
  };
  const onChildModalClose = () => {
    setIsChildModalVisible(false);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    }
  };
  const customTheme = {
    tagColor: '#41b341',
    attributeKeyColor: '#0074D9',
    attributeValueColor: '#b36b41',
    overflowBreak: true,
    textColor: '#FFF'
  };
  let items = [{
    key: 'Configuration',
    label: 'Configuration',
    children: (
      <div>
        <Row style={{ float: 'right', marginTop: '-40px' }}>
          <Button type="danger" style={{ fontWeight: 'bold', background: 'red', color: 'white' }} onClick={ShowXmlView}>
            {xmlView === false ? 'Show XmlView' : 'Hide XmlView'}
          </Button>
        </Row>
        <Form
          className="XMLForm"
          ref={userRef}
          onFinish={SaveConfigurationUpload}
          //onFinishFailed={onFinishFailed}
          layout="vertical"
          style={{ marginTop: '50px' }}
          initialValues={formObject}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={6}>
              <Form.Item
                label="Name :"
                name="Name"
                rules={[{ required: true, message: 'Please enter Name' }]}
              >
                <Input style={{ width: '350px' }} placeholder="Please enter" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={6}>
              <Form.Item
                label="Upload File :"
                name="XmlFormat"
                rules={[{ required: true, message: 'Please enter XmlFormat' }]}
              >
                <Upload
                  name="file"
                  accept="text/xml"
                  multiple={false}
                  beforeUpload={XMLConfigUpload}
                  onChange={handleChange}
                >
                  <Button style={{ width: '350px' }}>
                    <UploadOutlined /> Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={6}>
              <Form.Item
                label="DataObject :"
                name="DataObject"
                rules={[{ required: true, message: 'Please enter DataObject' }]}
              >
                <Input
                  style={{ width: '350px' }}
                  placeholder="Please enter"
                  onBlur={handleDataObject}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={6}>
              <Form.Item
                label="PayloadType :"
                name={'PayloadType'}
                rules={[{ required: true, message: 'Please enter PayloadType' }]}
              >
                <Select
                  style={{ width: '350px' }}
                  placeholder="Please select PayloadType "
                  onChange={onHandleChanePayload}
                >
                  <Option value="Request">Request</Option>
                  <Option value="Response">Response</Option>
                </Select>
              </Form.Item>
            </Col>
            {PayloadType === 'Response' ? (
              <>
                <Col className="gutter-row" span={6}>
                  <Form.Item
                    label="ResponseUrl :"
                    name={'ResponseUrl'}
                    rules={[{ required: true, message: 'Please enter ResponseUrl' }]}
                  >
                    <Input
                      placeholder=" Please Enter ResponseUrl"
                      style={{ width: '350px' }}
                    />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={6}>
                  <Form.Item
                    label="Group :"
                    name={'Group'}
                    rules={[{ required: true, message: 'Please enter Group' }]}
                  >
                    <Input placeholder="Please Enter Group" style={{ width: '350px' }} />
                  </Form.Item>
                </Col>
              </>
            ) : null}
            <Col className="gutter-row" span={6}>
              <Form.Item
                label="UniqueKeys :"
                name="UniqueKeys"
                rules={[{ required: true, message: 'Please select UniqueKeys' }]}
              >
                <Select
                  style={{ width: '350px' }}
                  mode="multiple"
                  placeholder="Please select"
                >
                  {UniqueKeysList &&
                    UniqueKeysList.dataKeys &&
                    UniqueKeysList.dataKeys.map((uniquekey, index) => {
                      return (
                        <Option key={index} value={uniquekey}>
                          {uniquekey}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={6}>
              <Form.Item
                label="Type:"
                name="Type"
                rules={[{ required: true, message: 'Please select Type' }]}
              >
                <Select
                  style={{ width: '350px' }}
                  // mode="multiple"
                  placeholder="Please select"
                >
                  {TypeList &&
                    TypeList.map((Type, index) => {
                      return (
                        <Option key={index} value={Type.Key}>
                          {Type.Key}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={6}>
              <Form.Item style={{ paddingTop: '22px' }}>
                <Button
                  type="primary"
                  onClick={onAddMapping}
                  disabled={AddParentDisable}
                >
                  Add Mapping
                </Button>
              </Form.Item>
            </Col>
            <Modal
              title={'Add Mapping'}
              open={isModalVisible}
              okText={'Save'}
              onOk={(e) => onFormItemSubmit(e)}
              onCancel={onModalClose}
            >
              <Form {...formItemLayout} ref={formRef} name="user_form">
                {UniqueKeysList &&
                  UniqueKeysList.dataKeys &&
                  UniqueKeysList.dataKeys.map((data, index) => (
                    <div key={index}>
                      <Form.Item
                        label={data}
                        name={data}
                        rules={[
                          {
                            required: true
                          }
                        ]}
                      >
                        <Select style={{ width: '350px' }}>
                          {UniqueKeysList &&
                            UniqueKeysList.rubusAliasKeys &&
                            UniqueKeysList.rubusAliasKeys.map((uniquekey, index) => {
                              return (
                                <Option key={index} value={uniquekey}>
                                  {uniquekey}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  ))}
              </Form>
            </Modal>
          </Row>
          <div>
            <Form.List name="child">
              {(child, { add, remove }) => (
                <>
                  <Form.Item>
                    <Button

                      style={{ background: '#29415a', color: '#fff' }}
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Add Fields{' '}
                    </Button>
                  </Form.Item>
                  <div>
                    {child.map(({ key, name }, index) => (
                      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} key={key}>
                        <Col className="gutter-row" span={6}>
                          <Form.Item
                            label="DataObject"
                            name={[name, 'DataObject']}
                            rules={[{ required: true, message: 'DataObject Missing' }]}
                          >
                            <Input
                              placeholder="DataObject"
                              onBlur={(e) => handleDataObjectChild(e)}
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={12}>
                          <Form.Item
                            label="XmlFormat"
                            name={[name, 'XmlFormat']}
                            rules={[{ required: true, message: 'XMLData Missing' }]}
                            style={{ width: '43vw' }}
                          >
                            <TextArea
                              placeholder="Input XmlFormat"
                              maxLength={10000}
                              style={{
                                height: 100
                              }}
                              onChange={(e) => ChildXMLData(e, name)}
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={6}>
                          <Form.Item
                            label="UniqueKeys:"
                            name={[name, 'UniqueKeys']}
                            rules={[
                              { required: true, message: 'Please select UniqueKeys' }
                            ]}
                          >
                            <Select
                              style={{ width: '350px' }}
                              mode="multiple"
                              placeholder="Please select"
                            >
                              {AllUniqueKeyList &&
                                AllUniqueKeyList[key] &&
                                AllUniqueKeyList[key].dataKeys &&
                                AllUniqueKeyList[key].dataKeys.map((uniquekey, index) => {
                                  return (
                                    <Option key={index} value={uniquekey}>
                                      {uniquekey}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={6}>
                          <Form.Item
                            label="Type:"
                            name={[name, 'Type']}
                            rules={[{ required: true, message: 'Please select Type' }]}
                          >
                            <Select
                              style={{ width: '350px' }}
                              // mode="multiple"
                              placeholder="Please select"
                            >
                              {TypeList &&
                                TypeList.map((Type, index) => {
                                  return (
                                    <Option key={index} value={Type.Key}>
                                      {Type.Key}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={6}>
                          <Form.Item style={{ paddingTop: '22px' }}>
                            <Button
                              type="primary"
                              key={key}
                              disabled={AddChildDisable}
                              onClick={() => {
                                onChildAdd(index);
                              }}
                            >
                              Add Mapping
                            </Button>
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={6}>
                          <Form.Item style={{ paddingTop: '24px' }}>
                            <Popconfirm
                              title="Are you sure that you want to delete the Child"
                              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                              onConfirm={() => remove(index)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Button danger key={key}>
                                <Tooltip title="Delete" placement="bottom">
                                  Remove Fields
                                </Tooltip>
                              </Button>
                            </Popconfirm>
                          </Form.Item>
                        </Col>
                        <Modal
                          key={selectedChildIndex}
                          title={'Add Mapping'}
                          open={isChildModalVisible}
                          okText={'Save'}
                          onOk={(e) => onChildModalSubmit(e, key)}
                          onCancel={onChildModalClose}
                        >
                          <Form
                            {...formItemLayout}
                            name="Child-Form"
                            initialValues={ChildMappingKeysArray[selectedChildIndex]}
                          >
                            {AllChildList &&
                              AllChildList[selectedChildIndex] &&
                              Object.keys(AllChildList[selectedChildIndex]) &&
                              Object.keys(AllChildList[selectedChildIndex]).map(
                                (data, index) => {
                                  return (
                                    <div key={index}>
                                      <Form.Item label={data} name={data}>
                                        <Select
                                          style={{ width: '350px' }}
                                          onChange={(value) =>
                                            onKeySelect(data, value, index, key)
                                          }
                                        >
                                          {AllUniqueKeyList &&
                                            AllUniqueKeyList[selectedChildIndex] &&
                                            AllUniqueKeyList[selectedChildIndex]
                                              .rubusAliasKeys &&
                                            AllUniqueKeyList[
                                              selectedChildIndex
                                            ].rubusAliasKeys.map((uniquekey) => {
                                              return (
                                                <Option key={key} value={uniquekey}>
                                                  {uniquekey}
                                                </Option>
                                              );
                                            })}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  );
                                }
                              )}
                          </Form>
                        </Modal>
                      </Row>
                    ))}
                  </div>
                </>
              )}
            </Form.List>
          </div>

          <Form.Item>
            <Button type="primary" className="SubmitButton" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
        <div style={{ marginTop: '70px' }}>
          {xmlView ? (
            <XMLViewer
              xml={XmlViewData}
              theme={customTheme}
              style={{ minWidth: '50vw', padding: '15px' }}
            />
          ) : null}
        </div>
      </div>
    ),
  }];
  return (
    <StyledHomepage>
      <Button type="dashed" style={{ marginBottom: '20px' }} onClick={() => props.navigate(-1)}>
        <DoubleLeftOutlined />
        Go Back
      </Button>
      <Tabs defaultActiveKey="Configuration" items={items} />
    </StyledHomepage>
  );
};


export default XMLConfiguration;
